import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";

export interface VendorsAnalyticsFilters {
  vendor_id: FilterValue[] | null;
  admin_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface VendorsAnalyticsSelectedFilters {
  vendor_id: FilterValue[] | null;
  admin_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface VendorsAnalyticsAPIFilters {
  vendor_id: FilterValue[] | null;
  admin_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForVendorsAnalyticsFilters(
  params: VendorsAnalyticsFilters | null,
  query_params: URLSearchParams,
): VendorsAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");
  return {
    vendor_id: params?.vendor_id ?? [],
    admin_id: params?.admin_id ?? [],
    product_id: params?.product_id ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
